require('./article.scss');

$(document).scroll(function() {
    if($(window).width() < 1024) {
        if ($(this).scrollTop() > 300) {
            $('.cff-modal-container').fadeIn();
        } else if ($(this).scrollTop() < 300) {
            $('.cff-modal-container').fadeOut();
        }
    }
});